import { Selectors } from 'Reducers'
import { Store } from 'redux'

// The email the ad platforms match on. Every conversion service needs it in the
// same normalised form (trimmed, lowercased) because that is what the platforms
// hash against, so it lives here rather than once per service.
//
// Takes the store rather than importing it: each service is handed one at init,
// and reaching for the module would close a cycle through store.ts.
export const getTrackedEmail = (store: Store | null): string | undefined => {
  if (!store) return undefined

  const state = store.getState()
  const trackedEmail = Selectors.getTrackedEmail(state)

  return trackedEmail ? trackedEmail.trim().toLowerCase() : undefined
}
